export default "__VITE_ASSET__CnbIYAW6__"